import { AvailableOn } from 'app/components/commons/Experience/Availability/utils';
import {
  MAXIMUM_DISCOUNT,
  MINIMAL_DISCOUNT_DAY_PACKAGE,
  MINIMAL_DISCOUNT_STAYCATION,
  checkDaysRestrictionsForSingleNight,
} from 'app/components/pages/Extranet/ExtranetInventory/Legacy/utils';
import type { ExtranetExperience } from 'app/typings/packages';
import { addDays, isAfter, isBefore } from 'app/utils/dayjs';

import { isPassed } from './dates';

export const isValidDiscount = (
  discount: number | undefined,
  dayPackage: boolean
) =>
  discount !== undefined &&
  discount <=
    (dayPackage
      ? MINIMAL_DISCOUNT_DAY_PACKAGE
      : -MINIMAL_DISCOUNT_STAYCATION) &&
  discount >= -MAXIMUM_DISCOUNT;

export const calculateDiscount = (discountPrice: number, price: number) => {
  if (!discountPrice) {
    return 0;
  }

  return price === 0
    ? 0
    : parseFloat((100 - (discountPrice * 100) / price).toFixed(2));
};

export const computeCrossRate = (
  packageId: number,
  experiences: ExtranetExperience[],
  date: string,
  isDayPackage: boolean,
  bar: number
) => {
  const filteredExperiences = experiences.filter((experience) => {
    if (!experience.included[packageId] || !experience.hotelId) {
      return false;
    }

    const isCheckinExperience = experience.availableDayLimits?.includes(
      AvailableOn.CHECK_IN
    );

    const dateToUseForClosingPeriods =
      isDayPackage || isCheckinExperience
        ? new Date(date)
        : addDays(new Date(date), 1);

    const isDuringClosingPeriod = experience.closingPeriods?.some(
      (closingPeriod) =>
        !isAfter(new Date(closingPeriod.start), dateToUseForClosingPeriods) &&
        !isBefore(new Date(closingPeriod.end), dateToUseForClosingPeriods)
    );

    const isDayAvailable = checkDaysRestrictionsForSingleNight(
      new Date(date),
      isDayPackage,
      experience.availableDays ?? [],
      experience.availableDayLimits ?? [],
      experience.availableDates ?? []
    );

    return !isDuringClosingPeriod && isDayAvailable;
  });

  const experiencesPrice = filteredExperiences.map(
    ({ price, priceDescription }) => {
      const parsedPrice = price || 0;

      if (priceDescription === '/pers.') {
        return parsedPrice * 2;
      }

      return parsedPrice;
    }
  );
  const packageValue = experiencesPrice.reduce(
    (acc, price) => acc + price,
    bar ?? 0
  );

  return packageValue;
};

export const getDiscountError = (
  discount: number | undefined,
  date: Date,
  isDayPackage: boolean,
  minimumDiscountOverrideDates: Date[],
  minimumDiscountOverride?: number
) => {
  const hasOverrideForDate = minimumDiscountOverrideDates.some(
    (overrideDate) =>
      new Date(overrideDate).toDateString() === new Date(date).toDateString()
  );

  const minimalDiscount = isDayPackage
    ? MINIMAL_DISCOUNT_DAY_PACKAGE
    : minimumDiscountOverride && hasOverrideForDate
      ? minimumDiscountOverride * 100
      : MINIMAL_DISCOUNT_STAYCATION;

  if (discount === undefined || isPassed(date)) {
    return '';
  }

  if (discount === Infinity) {
    return 'BAR needed';
  }

  if (discount > -minimalDiscount) {
    return `Min ${minimalDiscount}%`;
  }

  if (discount < -MAXIMUM_DISCOUNT) {
    return `Max ${MAXIMUM_DISCOUNT}%`;
  }

  return '';
};
